import { connect } from 'react-redux'

import { doRenderTicketListBeforeSearch } from 'actions/app'
import { doFetchTopLabels, doSearchLabels } from 'actions/labels'
import {
  doUpdateTicketSearchQuery,
  doToggleListSearchBoxFocused,
} from 'actions/search'

import {
  selectCurrentFolderContext,
  selectTicketListBeforeSearch,
} from 'selectors/app'
import { foldersByIdSelector } from 'selectors/folders'
import { selectLabelsByMailboxId } from 'selectors/labels'
import { selectLabelSearchResultsByTerm } from 'selectors/labelings'
import {
  selectCurrentUncommittedTicketSearchQueryString,
  selectCurrentCommittedTicketSearchQueryString,
  selectMailboxLessDisplayedSearchQueryString,
  selectCurrentTicketSearchSelectionStart,
  selectCurrentCommittedTicketSearchQueryCurrentPart,
} from 'selectors/search/base'
import { selectTicketSearchSuggestions } from 'selectors/search_suggestions'
import { selectIsFreeFormSearch, selectIsTypedSearch } from 'selectors/search'

import SearchView from 'components/ConversationList/Header/Search'

const select = state => {
  return {
    committedSearchQuery: selectCurrentCommittedTicketSearchQueryString(state),
    currentPart: selectCurrentCommittedTicketSearchQueryCurrentPart(state),
    folderContext: selectCurrentFolderContext(state),
    foldersById: foldersByIdSelector(state),
    isFreeFormSearch: selectIsFreeFormSearch(state),
    labelsByTerm: selectLabelSearchResultsByTerm(state),
    searchQuery: selectMailboxLessDisplayedSearchQueryString(state),
    searchSelectionStart: selectCurrentTicketSearchSelectionStart(state),
    suggestions: selectTicketSearchSuggestions(state),
    conversationListBeforeSearch: selectTicketListBeforeSearch(state),
    topLabels: selectLabelsByMailboxId(state).null,
    uncommittedSearchQuery: selectCurrentUncommittedTicketSearchQueryString(
      state
    ),
    isTypedSearch: selectIsTypedSearch(state),
  }
}

const perform = {
  doFetchTopLabels,
  doSearchLabels,
  doToggleListSearchBoxFocused,
  doUpdateTicketSearchQuery,
  onClearClick: doRenderTicketListBeforeSearch,
}

export default connect(select, perform)(SearchView)
